import { useEffect, useState } from "react";
import api from "../api/axios";
import Layout from "../components/Layout";
import Card from "../components/UI/Card";
import { useAuth } from "../context/AuthContext";

function StatCard({ label, value, sub, accent, loading }) {
  return (
    <Card className="p-5 flex flex-col gap-2 relative overflow-hidden">
      <div
        className="absolute top-0 left-0 w-1 h-full rounded-l-2xl"
        style={{ background: accent || "rgb(var(--primary))" }}
      />
      <div className="text-xs font-semibold uppercase tracking-widest opacity-50">{label}</div>
      {loading ? (
        <div className="mt-1"><div className="spinner" style={{ width: 24, height: 24, borderWidth: 2 }} /></div>
      ) : (
        <div className="text-3xl font-bold">{value ?? "—"}</div>
      )}
      {sub && <div className="text-xs opacity-50">{sub}</div>}
    </Card>
  );
}

export default function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState({ total: null });
  const [loadingStats, setLoadingStats] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/records", { params: { page: 1, limit: 1 } });
        setStats({ total: data.total });
      } catch {}
      finally { setLoadingStats(false); }
    })();
  }, []);

  return (
    <Layout>
      <div className="flex flex-col gap-6 max-w-5xl">
        <div>
          <div className="text-xs font-semibold uppercase tracking-widest opacity-40 mb-1">Overview</div>
          <h1 className="text-2xl font-bold">Dashboard</h1>
          <p className="text-sm opacity-50 mt-1">Welcome back, {user?.name}.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <StatCard
            label="Total Records"
            value={stats.total}
            sub="All uploaded leads"
            accent="rgb(var(--primary))"
            loading={loadingStats}
          />

         {/* { console.log("KK",user?.role)} */}
          
          <StatCard
            label="Your Role"
            value={user?.role === "SUPER_ADMIN" ? "Super Admin" : user?.role === "ADMIN" ? "Admin" : user?.role === "MANAGER" ? "Manager" : user?.role === "CALLER" ? "Caller" : user?.role === "VIEWER" ? "Viewer" : user?.role}
            sub="Access level"
            accent="#10b981"
          />
          <StatCard
            label="Status"
            value="Active"
            sub="System is running"
            accent="#f59e0b"
          />
        </div>

        <Card className="p-5">
          <div className="text-sm font-semibold mb-3 opacity-70">Quick Actions</div>
          <div className="flex flex-wrap gap-3">
            <a
              href="/records"
              className="px-4 py-2 rounded-xl text-sm font-medium text-white"
              style={{ background: "rgb(var(--primary))" }}
            >
              View Records
            </a>
          </div>
        </Card>
      </div>
    </Layout>
  );
}
